import React, { useState, useEffect } from 'react';
import Badge from '@mui/material/Badge';
import { Avatar, Box, Typography } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

// Helper to convert a string to camel case (capitalize each word)
function toCamelCase(str) {
    if (!str) return '';
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export function Contact(props) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [lastMessage, setLastMessage] = useState('');
    const [timestamp, setTimestamp] = useState('');
    const [profilePic, setProfilePic] = useState('');
    const [categories, setCategories] = useState('');
    const [labels, setLabels] = useState('');
    const [draft, setDraft] = useState('');
    const [wa_id, setWa_id] = useState('');
    const [selected, setSelected] = useState(props.selected ? props.selected : false);
    const [newMessages, setNewMessages] = useState(0);
    const [firstTag, setFirstTag] = useState('');
    const [isTemplate, setIsTemplate] = useState(false);
    const [isSentMessage, setIsSentMessage] = useState(false);

    useEffect(() => {
        setName(props.name ? props.name : 'SIN NOMBRE');
        setEmail(props.email);
        setProfilePic(props.profilePic);
        setCategories(props.categories);
        setLabels(props.labels);
        setDraft(props.draft);
        setNewMessages(props.newMessages);
        
        // Extract first tag from etiquetas
        if (props.etiquetas && props.etiquetas.length > 0) {
            const firstTagObj = props.etiquetas[0];
            setFirstTag(firstTagObj.label || firstTagObj.name || firstTagObj);
        } else {
            setFirstTag('');
        }
        // Safely extract the last message as a string
        try {
            let msg = props.lastMessage;
            let msgText = '';
            let templateName = '';
            let isTemplateMessage = false;
            
            if (typeof msg === 'string') {
                msgText = msg;
            } else if (msg && typeof msg === 'object') {
                const normalizedBody =
                    msg.text &&
                    typeof msg.text.body === 'object' &&
                    msg.text.body.body &&
                    typeof msg.text.body.body === 'object'
                        ? msg.text.body.body
                        : msg.text?.body;
                // Check if it's a template message first
                if (normalizedBody && typeof normalizedBody === 'object' && normalizedBody.name) {
                    isTemplateMessage = true;
                    templateName = normalizedBody.name;
                    msgText = `📋 ${templateName}`;
                            } else {
                isTemplateMessage = false;
                
                // Check if it's a sent message (from our number)
                const isSent = msg.from === process.env.REACT_APP_PHONE_NUMBER; // Our WhatsApp number
                setIsSentMessage(isSent);
                
                // Handle different message types
                if (typeof normalizedBody === 'string') {
                    msgText = normalizedBody;
                } else if (normalizedBody?.text?.body && typeof normalizedBody.text.body === 'string') {
                    // Handle nested text structure (sent messages)
                    msgText = normalizedBody.text.body;
                } else if (msg.body && typeof msg.body === 'string') {
                    msgText = msg.body;
                } else if (msg.type === 'reaction') {
                        const reaction = msg.reaction?.emoji || '👍';
                        msgText = `${reaction} Reacción`;
                    } else if (msg.type === 'document' || (msg.text?.body?.type === 'document')) {
                        // Handle document messages
                        let filename = 'Documento';
                        if (msg.document?.filename) {
                            filename = msg.document.filename;
                        } else if (msg.document?.title) {
                            filename = msg.document.title;
                        } else if (normalizedBody?.text?.caption) {
                            filename = normalizedBody.text.caption;
                        }
                        msgText = `📄 ${filename}`;
                    } else if (msg.type === 'image' || (msg.text?.body?.type === 'image')) {
                        // Handle image messages
                        let caption = '';
                        if (msg.image?.caption) {
                            caption = msg.image.caption;
                        } else if (normalizedBody?.text?.caption) {
                            caption = normalizedBody.text.caption;
                        }
                        msgText = caption ? `🖼️ ${caption}` : '🖼️ Imagen';
                    } else if (msg.type === 'video' || (msg.text?.body?.type === 'video')) {
                        // Handle video messages
                        let caption = '';
                        if (msg.video?.caption) {
                            caption = msg.video.caption;
                        } else if (normalizedBody?.text?.caption) {
                            caption = normalizedBody.text.caption;
                        }
                        msgText = caption ? `🎥 ${caption}` : '🎥 Video';
                    } else if (msg.type === 'audio') {
                        msgText = '🎵 Audio';
                    } else if (msg.type === 'location') {
                        msgText = '📍 Ubicación';
                    } else if (msg.type === 'contact') {
                        msgText = '👤 Contacto';
                    } else if (msg.type === 'sticker') {
                        msgText = '😀 Sticker';
                    } else if (msg.type === 'interactive') {
                        if (msg.interactive?.type === 'button_reply') {
                            msgText = `🔘 ${msg.interactive.button_reply?.title || 'Botón'}`;
                        } else if (msg.interactive?.type === 'list_reply') {
                            msgText = `📋 ${msg.interactive.list_reply?.title || 'Lista'}`;
                        } else {
                            msgText = '📱 Interactivo';
                        }
                    } else if (msg.type && typeof msg.type === 'string') {
                        msgText = msg.type;
                    } else {
                        msgText = '[Mensaje]';
                    }
                }
            }
            
            setIsTemplate(isTemplateMessage);
            
            if (!isTemplateMessage) {
                setLastMessage(msgText.length > 20 ? msgText.slice(0, 20) + '...' : msgText.slice(0, 20));
            } else {
                setLastMessage(msgText);
            }

            //set the timestamp as date, if the date is today, show the time, if not, show the date
            let timestamp = parseInt(props.lastMessageTimestamp);
            let date = new Date(props.lastMessageTimestamp * 1000);
            let year = date.getFullYear();
            if (year > 2100) {
                date = new Date(props.lastMessageTimestamp);
                year = date.getFullYear();
            }
            let today = new Date();
            if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear()) {
                setTimestamp(date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).split(' ')[0]);
            } else {
                setTimestamp(date.toLocaleDateString());
            }
        } catch (error) {
            setLastMessage('');
        }
    }, [props.name, props.draft, props.lastMessage, props.newMessages]);

    // Generate initials for avatar
    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            width: '100%',
            gap: 2,
            p: 2,
            fontFamily: 'Inter, Roboto, Arial, sans-serif',
            background: selected ? '#f5f6f6' : 'inherit',
            borderRadius: '10px',
            transition: 'background 0.2s',
        }}>
            {/* Profile Picture */}
            <Box sx={{ position: 'relative' }}>
                <Avatar
                    src={profilePic || "/profile1.jpg"}
                    sx={{ 
                        width: 49, 
                        height: 49,
                        bgcolor: profilePic ? 'transparent' : '#008069',
                        color: profilePic ? 'inherit' : '#ffffff',
                        fontSize: '18px',
                        fontWeight: 600
                    }}
                >
                    {!profilePic && getInitials(name)}
                </Avatar>
                {newMessages > 0 && (
                    <Badge
                        badgeContent={newMessages}
                        color="primary"
                        sx={{
                            position: 'absolute',
                            top: -5,
                            right: -5,
                            '& .MuiBadge-badge': {
                                backgroundColor: '#25D366',
                                color: '#ffffff',
                                fontSize: '11px',
                                fontWeight: 600,
                                minWidth: '18px',
                                height: '18px'
                            }
                        }}
                    />
                )}
            </Box>

            {/* Contact Info */}
            <Box sx={{ 
                flex: 1, 
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }}>
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'flex-start',
                    mb: 0.5
                }}>
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            fontWeight: newMessages > 0 ? 600 : 500, // Bolder if unread
                            fontSize: '17px',
                            color: newMessages > 0 ? '#008069' : '#111b21', // WhatsApp green for unread
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontFamily: 'Inter, Roboto, Arial, sans-serif',
                            letterSpacing: '0.01em',
                        }}
                    >
                        {toCamelCase(name)}
                    </Typography>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            color: '#667781',
                            fontSize: '12px',
                            fontWeight: 400,
                            ml: 1,
                            flexShrink: 0,
                            fontFamily: 'Inter, Roboto, Arial, sans-serif',
                        }}
                    >
                        {timestamp}
                    </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                    {firstTag && (
                        <Box
                            sx={{
                                backgroundColor: '#f0f2f5',
                                color: '#667781',
                                fontSize: '11px',
                                fontWeight: 500,
                                px: 1,
                                py: 0.5,
                                borderRadius: '16px',
                                border: '1px solid #e9edef',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.5,
                                maxWidth: '120px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                '&:hover': {
                                    backgroundColor: '#e4e6e8',
                                    borderColor: '#d1d5db'
                                }
                            }}
                        >
                            <LocalOfferIcon sx={{ fontSize: '12px', color: '#667781' }} />
                            {firstTag}
                        </Box>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                        {isSentMessage && (
                            <span style={{
                                fontSize: '12px',
                                color: '#008069',
                                fontWeight: 600,
                                marginRight: '4px'
                            }}>
                                →
                            </span>
                        )}
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                color: isTemplate ? '#008069' : (newMessages > 0 ? '#111b21' : '#667781'),
                                fontSize: '14px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                lineHeight: '1.3',
                                fontFamily: 'Inter, Roboto, Arial, sans-serif',
                                fontWeight: isTemplate ? 600 : (newMessages > 0 ? 600 : 400),
                                flex: 1,
                                fontStyle: isTemplate ? 'italic' : 'normal',
                                opacity: isSentMessage ? 0.8 : 1
                            }}
                        >
                            {draft ? `Draft: ${draft}` : lastMessage}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}